module.exports = __webpack_public_path__ + "assets/images/phoned35b38b629d8783f7b39d86dea7f46d7.svg";